import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Position } from "../../../../domain/models/position-model";
import { InsertContext } from "./store";
import { StoreItem } from "../../../../domain/models/storage-item";
export const MobileInsert: React.FC = () => {
  const [position, setPosition] = useState<Position | null>(null);
  const [list, setList] = useState<StoreItem[] | null>(null);
  return (
    <InsertContext.Provider value={{ position, setPosition, list, setList }}>
      <Outlet />
    </InsertContext.Provider>
  );
};
